import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappChat.css";
const WhatsAppChat = () => {
  const phoneNumber = "919517889797";
  const message = "Hi";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-chat"
      aria-label="Chat on WhatsApp"
    >
      <div className="whatsapp-icon">
        <FaWhatsapp />
      </div>

    </a>
  );
};

export default WhatsAppChat;